export enum WaitTimeStatus {
  Good = 10,
  Busy = 20,
  Overloaded = 30,
  Critical = 40,
}
